import { ApexOptions } from 'apexcharts';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
const ColumnsChart = (props: {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
  options: ApexOptions;
}) => {

  return (
    <div>
      <ReactApexChart
        options={props.options}
        type="bar"
        series={props.options.series}
        height={350}
      />
    </div>
  );
};

export default ColumnsChart;
